import { useTranslation } from "react-i18next";
import { User } from "lucide-react";

import { useAppSelector } from "@/hooks/useReduxHooks";
import { selectUser } from "@/store/slices/user.slice";
import { Avatar, AvatarImage, AvatarFallback } from "@/components/ui/avatar";

export const ReportingTo = () => {
  const { t } = useTranslation("my-space");

  const { user } = useAppSelector(selectUser);

  const reportingManager = user?.employmentDetails?.reportingManager;
  const hasReportingManager = reportingManager && (reportingManager.firstName || reportingManager.lastName);

  if (!hasReportingManager) return null;
  return (
    <div className="hidden md:flex items-center gap-2 relative p-4 border-s border-border">
      <div>
        <p className="text-xs text-muted-foreground">{t("dashboard.reporting_to")}</p>
        <p className="text-sm font-medium truncate">{`${reportingManager.firstName ?? ""} ${
          reportingManager.lastName ?? ""
        }`}</p>
      </div>
      <Avatar className="w-10 h-10 rounded-xs border border-white shadow-xs bg-info-muted flex justify-center items-center">
        <AvatarImage
          src={reportingManager.profileImage}
          alt={t("interp.profile_photo_alt", {
            name: `${reportingManager.firstName ?? ""} ${reportingManager.lastName ?? ""}`.trim(),
          })}
          className="object-cover"
        />
        <AvatarFallback className="bg-info-muted rounded-none">
          <User size={14} fill="var(--color-primary)" stroke="var(--color-primary)" />
        </AvatarFallback>
      </Avatar>
    </div>
  );
};
